import type { EditorCore } from "@loumy/contracts";
import { PlatformerLevel, type PlatformerUi } from "./level";

// D75 — der EditorCore des 2D-Platformers (React-frei, Backbone-tauglich wie demo-board). Registriert
// sich über die EditorRegistry (ALL_EDITOR_CORES); die zugehörige EditorUI (Grid-Viewport/Gizmos/Tools/
// Menüs) lebt lazy im Web-Frontend (apps/web, EDITOR_UI_LOADERS). „Nichts referenziert einen Editor hart".

export const platformer2dCore: EditorCore<PlatformerLevel, PlatformerUi> = {
  id: "platformer-2d",
  label: "2D-Platformer",
  icon: { name: "canvas" },
  documentSchema: PlatformerLevel,
  createDocument() {
    return { grid: { cell: 16 }, instances: [] };
  },
  createUiState() {
    return { activeTool: "select", zoom: 1, pan: { x: 0, y: 0 }, snap: true, designMode: "stairs", areaShape: "rect", roleBrushes: {} };
  },
  layoutHints: {
    toolbar: { defaultSize: 48, collapsible: false },
    tools: { defaultSize: 220, collapsible: true },
    outliner: { defaultSize: 300, collapsible: true },
    details: { defaultSize: 300, collapsible: true },
  },
  // D72 — Multi-Dokument-Host: der „Levels"-Switcher (Substantiv/Verzeichnis/Endung editor-spezifisch).
  documentSet: { noun: "Level", dir: "levels", extension: ".level.json" },
};
